<template>
  <div>

    <v-layout v-if="loading" align-center justify-center :style="screenHeigthStyle">
      <v-progress-circular indeterminate color="primary" v-if="loading" class="mb-4"/>
    </v-layout>

    <v-layout v-else-if="error" align-center justify-center column :style="screenHeigthStyle">
      <request-response-placeholder
        showPlaceholder
        message="Ocorreu um erro, tente novamente !"/>
    </v-layout>

    <div column v-else>
      <slot></slot>
    </div>

  </div>
</template>

<script>
import { isMobile } from '@/helpers/deviceDetection'
import RequestResponsePlaceholder from '@/components/RequestResponsePlaceholder'

export default {
  name: 'LoadingContent',

  components: {
    RequestResponsePlaceholder
  },

  props: {
    loading: {
      type: Boolean,
      required: true
    },

    error: {
      type: Boolean,
      required: false
    },

    isTab: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    toolbarHeight () {
      return isMobile() ? '56px' : '64px'
    },

    screenHeigthStyle () {
      return this.isTab ? `height: calc(100vh - ${this.toolbarHeight});` : ''
    }
  }
}
</script>
